import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useBlocker } from 'react-router';


// Replacement for <Prompt /> from react-router v4/v5: asks for confirmation
// before leaving the page while `when` is true.
const Prompt = ({ when = true, message }) => {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }
    const text = typeof message === 'function' ? message(blocker.location) : message;
    if (text === true || window.confirm(text)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);

  return null;
};

Prompt.propTypes = {
  when: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
};

export default Prompt;
